<template lang="pug">
  i.icon
    slot

</template>

<script>
export default {
  name: 'Icon',
};
</script>

<style lang="scss" scoped>
.icon {
  font-style: normal;
}
</style>
